import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import Lottie from 'react-lottie';
import './TagResponseModal.css';
import SuccessIcon from '../../../assets/lottie/success.json';
import FailedIcon from '../../../assets/lottie/fail.json';

const TagResponseModal = ({ open, onClose, response }) => {
  if (!response) return null;

  const getModalContent = () => {
    const lottieOptions = animationData => ({
      loop: false,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    });

    if (response.status === 'success') {
      return {
        lottieAnimation: <Lottie options={lottieOptions(SuccessIcon)} height={120} width={120} />,
        title: 'Success',
        message: response.message || 'Tag created and added successfully',
        type: 'success',
      };
    } else if (response.status === 'invalid') {
      return {
        lottieAnimation: <Lottie options={lottieOptions(FailedIcon)} height={120} width={120} />,
        title: 'Invalid Tag',
        message: response.message || 'The tag is not a recognized category',
        type: 'invalid',
      };
    } else {
      return {
        lottieAnimation: <Lottie options={lottieOptions(FailedIcon)} height={120} width={120} />,
        title: 'Error',
        message:
          response.detail || response.message || 'An error occurred while processing the tag',
        type: 'error',
      };
    }
  };

  const content = getModalContent();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth className="tag-response-modal">
      <Box className="tag-response-modal-header">
        <Box className="tag-response-modal-animation">{content.lottieAnimation}</Box>
        <Typography variant="h5" className={`tag-response-modal-title-${content.type}`}>
          {content.title}
        </Typography>
      </Box>
      <DialogContent className="tag-response-modal-content">
        <Typography variant="body1">{content.message}</Typography>
      </DialogContent>
      <DialogActions className="tag-response-modal-actions">
        <Button
          onClick={onClose}
          variant="contained"
          className={`tag-response-modal-button-${content.type}`}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TagResponseModal;
